// src/shared/key-activate.js
//
// v136.8 (accessibility audit, 16 Oct 2026). Some tappable things in Shift are not <button>s: a chat list row, a
// "reset location" link, a log entry card. A mouse or a finger can use them; a keyboard or a switch user could not
// even reach them. The fix for each is two attributes in its markup, role="button" and tabindex="0", and this one
// listener, which makes Enter and Space on such an element do what a click does (as a real button would).
//
// One listener for the whole page, installed once however many bundles import this file. It only acts on an element
// that says role="button" and is not itself a native control, so real buttons, links, inputs and text boxes keep their
// own keys.

const NATIVE = { BUTTON: 1, A: 1, INPUT: 1, TEXTAREA: 1, SELECT: 1, SUMMARY: 1 };

export function activateOnKey(e) {
  if (!e || (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar')) return false;
  const el = e.target;
  if (!el || el.nodeType !== 1 || !el.getAttribute) return false;
  if (el.getAttribute('role') !== 'button' || NATIVE[el.nodeName.toUpperCase()] || el.isContentEditable) return false;
  if (e.repeat) { e.preventDefault(); return true; }
  e.preventDefault();   // Space would otherwise scroll the page
  el.click();
  return true;
}

if (typeof document !== 'undefined' && typeof window !== 'undefined' && !window.__shiftKeyActivate) {
  window.__shiftKeyActivate = true;
  document.addEventListener('keydown', activateOnKey);
}
